import { createRouter, createWebHistory } from 'vue-router'
import { ReviseMeta } from '@/util/meta'
const bdRoutes = Array.from({ length: 10 }, (_, i) => {
  const num = (i + 1).toString().padStart(2, '0')
  return {
    path: `/bdpz/${num}`,
    component: () => import(`./views/bd/${num}.vue`),
  }
})
const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面
    {
      path: '/',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/forum/:id?',
      component: () => import('./views/forum/index.vue'),
    },
    {
      path: '/forum/:page/:id?',
      component: () => import('./views/forum/index.vue'),
    },
    {
      path: '/m',
      component: () => import('./views/yy/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    // 名人和联盟
    {
      path: '/msg',
      component: () => import('./views/msg/index.vue'),
      meta: {
        title: '九州名士阁 - 三国群英传·策定九州',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    // 预约官网
    {
      path: '/home',
      component: () => import('./views/yygw/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/home/m',
      component: () => import('./views/yygw/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/season/s2',
      component: () => import('./views/s2/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/season/s3',
      component: () => import('./views/s3/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/season/s4',
      component: () => import('./views/s4/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/season/s5',
      component: () => import('./views/s5/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/season/s6',
      component: () => import('./views/s6/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/season/s7',
      component: () => import('./views/s7/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/season/s8',
      component: () => import('./views/s8/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/season/s9',
      component: () => import('./views/s9/index.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    {
      path: '/role',
      component: () => import('./views/yygw/com/reward.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    // 预约特殊页面（只在小程序用）
    {
      path: '/weixin',
      component: () => import('./views/yygw/weixin.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    // 预约特殊页面（只在小程序用）
    {
      path: '/weixin/m',
      component: () => import('./views/yygw/weixin.vue'),
      meta: {
        title:
          '《三国群英传：策定九州》官网-星辉游戏-首款三国空战策略手游-三国群英传策定九州礼包福利下载',
        keywords:
          '率土之滨,三国志:战略版,九牧之野,重返帝国,世界启元,三国群英传策定九州PC版,三国群英传策定九州手游礼包码,三国群英传策定九州手游福利,三国群英传策定九州手游下载, 三国群英传策定九州手游官网,策定九州礼包, 策定九州礼包码, 策定九州福利, 策定九州下载, 策定九州官网,九州礼包,九州礼包码,九州福利,九州下载,九州官网,策定礼包,策定礼包码,策定福利,策定下载,策定官网,三策礼包,三策礼包码,三策福利,三策下载,三策官网,策定九州手游礼包,策定九州手游礼包码,策定九州手游福利,策定九州手游下载,策定九州手游官网,三国群英传：策定九州礼包, 三国群英传：策定九州礼包码, 三国群英传：策定九州福利, 三国群英传：策定九州下载, 三国群英传：策定九州官网,策定九州手游礼包, 策定九州手游礼包码, 策定九州手游福利, 策定九州手游下载, 策定九州手游官网,三国群英传策定九州礼包, 三国群英传策定九州礼包码, 三国群英传策定九州福利, 三国群英传策定九州下载, 三国群英传策定九州官网',
        description:
          '《三国群英传：策定九州》是一款正版三国即时战争策略手游。游戏可带你穿越回那个英雄辈出的时代，重温酣战岁月。游戏采用写实画风，细腻还原三国战场的风貌，让你仿佛身临其境，亲历那些历史上的著名战役。作为真RTS游戏，游戏支持灵活拖拽操作，让你在瞬息万变的战场上迅速作出反应，实现精准指挥。此外，游戏的兵种具有真实兵种特定，比如弓兵可布局远程风筝战术，展现你的战略智慧。更值得一提的是，游戏注重平衡性，降肝减负，让你轻松养成武将、升级建筑，享受攻城掠地的乐趣，把时间与精力主要投入在作战策略上。《三国群英传：策定九州》，等你来策马扬鞭，一统九州！ ',
      },
    },
    // 百度品专
    ...bdRoutes,
    // 404跳转到前置页
    {
      path: '/:catchAll(.*)',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  // 路由发生变化改变description和keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description)
  const userAgent = navigator.userAgent.toLowerCase()
  const isMobile = /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(userAgent)

  if (isMobile) {
    if (to.path == '/') {
      next({ path: '/m', query: to.query, hash: to.hash })
    } else if (to.path == '/home') {
      next({ path: '/home/m', query: to.query, hash: to.hash })
    } else {
      next()
    }
  } else {
    if (to.path == '/m') {
      next({ path: '/', query: to.query, hash: to.hash })
    } else if (to.path == '/home/m') {
      next({ path: '/home', query: to.query, hash: to.hash })
    } else {
      next()
    }
  }
  // next()
})

export default router
